let e = {}

export default {
  on: function (name, cb) {
    if (e[name]) {
      e[name].push(cb)
    } else {
      e[name] = [cb]
    }
  },
  once: function (name, cb) {
    let mCb = () => {
      cb(arguments)
      this.off(name, mCb)
    }
    this.on(name, mCb)
  },
  off: function (name, fn) {
    let t = e[name]
    if (t) {
      if (!fn) {
        delete e[name]
      } else {
        let index = t.indexOf(fn)
        ~index && t.splice(index, 1)
      }
    }
  },
  emit(name, data) {
    let t = e[name]
    if (t) {
      t.forEach(ele => {
        ele(data)
      })
    }
  }
}